import React, {Component} from "react";
import {connect} from "react-redux";
import * as actions from "../../../actions/index";
import {Col, Row, TabContent, TabPane,} from "reactstrap";
import ButtonIconWithTooltip from "../../../components/ButtonIconWithTooltip";
import "../../../assets/css/request-received.css";
import {getData, LOGIN, setData} from "../../../util/storage";
import {
    subscribeToFireStore,
    subscribeToPrivateFireStore,
    unsubscribeToFireStore,
    updateAvailabilityRequestUser,
} from "../../../util/firebase/firestore";
import {getEncryptedIdForBroadcaster} from "../../../util/broadcast_util";
import ConfirmationModal from "../../../components/modal/ConfirmationModal";
import closeAvailability from "../../../assets/images/end-availability.svg";
import {hideModal, isEmpty, LogException, navigate, showModal, vuepayAlert, vuePayLog,} from "../../../util/utility";
import ShareButtonComponent from "../../../components/ShareButtonComponent";
import RequestReceivedTabComponent from "../../../components/RequestReceivedTabComponent";
import RequestSearchComponent from "../../../components/RequestSearchComponent";
import OneonOneRequests from "../../../components/OneonOneRequests"
import GroupRequests from "../../../components/GroupRequests"
import share from "../../../util/share";
import helpAvailability from "../../../assets/images/help.svg";
import {checkValidBroadcast, getBroadcastID} from "../../../util/broadcast/start_broadcast";
import {updateJWTToken} from "../../../util/broadcast/create";

const getNumberOfCount = (requestList) => {
    let countData = requestList.filter((request) => {
        return request.status === 0;
    });
    return countData.length;
};

const getRequestCount = (availability, type) => {

    if (availability && availability.groupAvailabilityList && type === "group") {
        return getNumberOfCount(availability.groupAvailabilityList)
    } else if (availability && availability.oneToOneAvailabilityList && type === "onetoone") {
        return getNumberOfCount(availability.oneToOneAvailabilityList)
    } else {
        return 0;
    }
};

const screename = "BroadcastAvailabilityRequests";
class BroadcastAvailabilityRequests extends Component {
    constructor() {
        super();
        this.state = {
            activeTab: "1",
            isChecked: null,
            selectAllCheckbox: false,
            checkboxStore: [],
            oneToOneRequests: 0,
            groupRequests: 0,
            req_id: null,
            broadcasterRequestId: null,
            broadcasterRequestIds: [],
            broadcasterType: null,
            favUserId: null,
            blockUserId: null,
            sessionType: null,
            broadcast: null,
            viewerAcceptedPrivateRequest: false,
            shareList: share.listArray,
            helpTooltipOpen: false,
            editTooltipOpen: false,
            closeTooltipOpen: false,
            oneToOneRequest: [],
            groupRequest: [],
            getOneToOneSearchValue: "",
            getGroupSearchValue: "",
            searchedOneToOneData: [],
            searchedOneToOneDataStatus: false,
            searchedGroupData: [],
            searchedGroupDataStatus: false,
            viewer: null,
            isSubscribed: false,
        };

        //all the functions used in this component should be listed here for better documentation
    }

    toggle = (tab) => {
        if (this.state.activeTab !== tab) {
            this.setState({
                activeTab: tab,
                favUserId: null,
                blockUserId: null,
                sessionType: null,
            });
        }
    };

    // Select radio style and hook
    radioToggle = (event) => {
        this.setState({
            isChecked: event.target.value,
        });
    };

    UNSAFE_componentWillReceiveProps(nextProps) {

        if (nextProps.availability && nextProps.availability.payload) {
            //if the status_code received from the server is 200 means the user has successfully done the forgot password
            if (nextProps.availability.payload.status_code === 200 || nextProps.availability.payload.status_code === 201) {
                getData(LOGIN).then((data) => {
                    if (!isEmpty(data)) {
                        this.props.getUserDetails(data.token, data.api_token);
                    }
                });
                nextProps.resetAvailability();
                vuepayAlert("success", nextProps.availability.payload.message);
                navigate(this.props, "broadcaster_availability");
            } else {
                //if the status_code received from the server is NOT 200 means there has been some error occurred
                nextProps.resetAvailability();
                vuepayAlert("error", nextProps.availability.payload.message);
            }
        }

        if (
            nextProps &&
            nextProps.availability &&
            nextProps.availability.favoriteUserSuccess
        ) {
            updateAvailabilityRequestUser(
                this.state.favUserId,
                nextProps.account_management &&
                nextProps.account_management.userDetails &&
                nextProps.account_management.userDetails.broadcaster[0]
                    .availability[0].broadcast[0].id,
                this.state.sessionType,
                "favorite",
                true,
                (jsonData) => {
                    this.state.sessionType === "group"
                        ? jsonData &&
                        jsonData.length > 0 &&
                        this.setState({
                            groupRequests: jsonData && jsonData.length > 0 && jsonData,
                        })
                        : jsonData &&
                        jsonData.length > 0 &&
                        this.setState({
                            oneToOneRequests: jsonData && jsonData.length > 0 && jsonData,
                        });
                }
            );
            this.props.resetFavouriteUser();
        }
        if (
            nextProps &&
            nextProps.availability &&
            nextProps.availability.unFavoriteUserSuccess
        ) {
            updateAvailabilityRequestUser(
                this.state.favUserId,
                nextProps.account_management &&
                nextProps.account_management.userDetails &&
                nextProps.account_management.userDetails.broadcaster[0]
                    .availability[0].broadcast[0].id,
                this.state.sessionType,
                "favorite",
                false,
                (jsonData) => {
                    this.state.sessionType === "group"
                        ? this.setState({
                            groupRequests: jsonData && jsonData,
                        })
                        : this.setState({
                            oneToOneRequests: jsonData && jsonData,
                        });
                }
            );
            this.props.resetFavouriteUser();
        }
        if (
            nextProps &&
            nextProps.availability &&
            nextProps.availability.removeAvailabilityUserRequestSuccess
        ) {
            updateAvailabilityRequestUser(
                this.state.favUserId,
                nextProps.account_management &&
                nextProps.account_management.userDetails &&
                nextProps.account_management.userDetails.broadcaster[0]
                    .availability[0].broadcast[0].id,
                this.state.sessionType,
                "remove",
                2,
                (jsonData) => {
                    this.state.sessionType === "group"
                        ? this.setState({
                            groupRequests: jsonData && jsonData,
                        })
                        : this.setState({
                            oneToOneRequests: jsonData && jsonData,
                        });
                }
            );
            this.props.resetRemoveUserRequest();
        }
        if (
            nextProps &&
            nextProps.availability &&
            nextProps.availability.blockUserSuccess
        ) {
            updateAvailabilityRequestUser(
                this.state.blockUserId,
                nextProps.account_management &&
                nextProps.account_management.userDetails &&
                nextProps.account_management.userDetails.broadcaster[0]
                    .availability[0].broadcast[0].id,
                this.state.sessionType,
                "block",
                2,
                (jsonData) => {
                    this.state.sessionType === "group"
                        ? this.setState({
                            groupRequests: jsonData && jsonData,
                        })
                        : this.setState({
                            oneToOneRequests: jsonData && jsonData,
                        });
                }
            );
            this.props.resetBlockUser();
        }

        if (nextProps && nextProps.availability &&
            nextProps.availability.broadcasterAcceptRequestSuccess
        ) {
            this.props.resetbroadcasterAcceptRequest();
            if (nextProps.availability.broadcasterAcceptRequest &&
                nextProps.availability.broadcasterAcceptRequest.error &&
                nextProps.availability.broadcasterAcceptRequest.error.status_code === 400
            ) {
                vuepayAlert(
                    "error",
                    nextProps.availability.broadcasterAcceptRequest.error.message
                );
            } else {

                vuepayAlert(
                    "success",
                    nextProps.availability.broadcasterAcceptRequest.success.message
                );
                if (this.state.broadcasterType !== "group") {
                    getData(LOGIN).then((data) => {
                        if (!isEmpty(data)) {
                            const jsonData = {
                                device: this.props.device,
                                broadcast_id:
                                nextProps.account_management &&
                                nextProps.account_management.userDetails &&
                                nextProps.account_management.userDetails.broadcaster[0]
                                    .availability[0].broadcast[0].id,
                            };
                            this.props.createPrivateBroadcast(
                                data.token,
                                data.api_token,
                                jsonData
                            );
                        }
                    });
                } else if (this.state.broadcasterType === "group") {

                    // getData(LOGIN).then((data) => {
                    //     if (!isEmpty(data)) {
                    //         setData(LOGIN, {
                    //             ...data,
                    //             token: nextProps.availability.broadcasterAcceptRequest.success.data.jwt_token,
                    //         });
                    //     }
                    // });

                    //check if all the props passed through browser is valid and must consist of  broadcast_id, session_id, token
                    getBroadcastID(this.props.location)
                        .then((broadcastDetail) => {

                            const payload  = nextProps.availability.broadcasterAcceptRequest.success;
                            const broadcastID = broadcastDetail.broadcast_id;
                            const sessionID = nextProps.availability.broadcasterAcceptRequest.success.data.session_id;
                            const token = nextProps.availability.broadcasterAcceptRequest.success.data.token;
                            const jwt_token = nextProps.availability.broadcasterAcceptRequest.success.data.jwt_token;
                            const availability_id = getEncryptedIdForBroadcaster(this.props.account_management.userDetails.broadcaster[0].availability[0].id);

                            updateJWTToken(payload, () => {
                                const path = `/broadcaster/start/broadcast?session_id=${sessionID}&broadcast_id=${broadcastID}&token=${token}&availability=true&availability_id=${availability_id}`;

                                this.props.history.push(path, {
                                    session_id: sessionID,
                                    jwt_token: jwt_token,
                                    broadcast_id: broadcastID,
                                    token: token,
                                    requestId: this.state.broadcasterRequestId,
                                    viewerProfile: this.state.viewer,
                                    requestType: "group",
                                });

                                this.props.resetBroadcastDetail();
                            });
                        })
                        .catch((err) => {
                            LogException("BroadcastAvailabilityRequests", "checkValidBroadcast", err);
                            vuepayAlert("error", "Sorry we didn't recognise the broadcast details and have to navigate you out of it, please try again later.");
                        });

                }
            }
        }

        /*------------START SESSION--------------*/

        if (
            nextProps.broadcast &&
            nextProps.broadcast.private_broadcast_payload != null
        ) {
            getData(LOGIN).then((data) => {
                if (!isEmpty(data)) {
                    setData(LOGIN, {
                        ...data,
                        token: nextProps.broadcast.private_broadcast_payload.data.token,
                    });
                }
            });

            //check if all the props passed through browser is valid and must consist of  broadcast_id, session_id, token
            getBroadcastID(this.props.location)
                .then((broadcastDetail) => {
                    const payload  = nextProps.broadcast.private_broadcast_payload;
                    const broadcastID = broadcastDetail.broadcast_id;
                    const sessionID = nextProps.broadcast.private_broadcast_payload.data.session_id;
                    const token = nextProps.broadcast.private_broadcast_payload.data.token;
                    const jwt_token = nextProps.broadcast.private_broadcast_payload.data.jwt_token;
                    const private_broadcast_id = nextProps.broadcast.private_broadcast_payload.data.id;
                    const availability_id = getEncryptedIdForBroadcaster(this.props.account_management.userDetails.broadcaster[0].availability[0].id);
                    updateJWTToken(payload, () => {
                        const path = `/broadcaster/start/broadcast?session_id=${sessionID}&broadcast_id=${broadcastID}&token=${token}&private_broadcast_id=${getEncryptedIdForBroadcaster(private_broadcast_id)}&availability=true&availability_id=${availability_id}`;

                        this.props.history.push(path, {
                            session_id: sessionID,
                            jwt_token: jwt_token,
                            broadcast_id: broadcastID,
                            token: token,
                            requestId: this.state.broadcasterRequestId,
                            viewerProfile: this.state.viewer,
                            requestType: "onetoone",
                        });

                        this.props.resetBroadcastDetail();
                    });


                })
                .catch((err) => {
                    LogException("BroadcastAvailabilityRequests", "checkValidBroadcast", err);
                    vuepayAlert("error", "Sorry we didn't recognise the broadcast details and have to navigate you out of it, please try again later.");
                });
        }

        /*--------------------------*/

        if (
            this.props.account_management.userDetails &&
            this.props.account_management.userDetails.broadcaster.length > 0 &&
            this.props.account_management.userDetails.broadcaster[0].availability
                .length > 0 && !this.state.isSubscribed
        ) {

            this.setState({
                isSubscribed: true
            })
            let broadcastId =
                nextProps.account_management &&
                nextProps.account_management.userDetails.broadcaster.length > 0 &&
                nextProps.account_management.userDetails.broadcaster[0].availability
                    .length > 0 &&
                nextProps.account_management.userDetails.broadcaster[0].availability[0]
                    .broadcast[0].id;

            broadcastId &&
            subscribeToFireStore(
                broadcastId.toString(),
                this.onGroupRequestUpdate,
                this.onOneToOneRequestUpdate
            );
            broadcastId &&
            subscribeToPrivateFireStore(
                broadcastId.toString(),
                this.privateSessionUpdate
            )
        }
    }

    privateSessionUpdate = (querySnapshot) => {
        let privateRequest = [];
        querySnapshot.forEach((doc) => {
            privateRequest.push(doc.data());
        });

        this.props.updatePrivateAvailabilityList(
            privateRequest && privateRequest
        );
    };

    onGroupRequestUpdate = (querySnapshot) => {
        if (querySnapshot.exists) {
            let groupRequest = [];
            querySnapshot.forEach((doc) => {
                if (doc.exists && doc.data().status === 0) {
                    groupRequest.push(doc.data());
                }
            });
            this.setState({
                groupRequestList: groupRequest,
            }, () => {
                vuePayLog(screename,"groupRequestList", this.state.groupRequestList)
            });
            this.props.updateGroupAvailabilityList(groupRequest);
        }
    };

    onOneToOneRequestUpdate = (querySnapshot) => {
        if (querySnapshot.exists) {
            let oneToOneRequest = [];
            querySnapshot.forEach((doc) => {
                if (doc.exists && doc.data().status === 0) {
                    oneToOneRequest.push(doc.data());
                }
            });

            this.setState({
                oneToOneRequestList: oneToOneRequest,
            }, () => {
                vuePayLog(screename,"oneToOneRequestList", this.state.oneToOneRequestList)
            });
            this.props.updateOneToOneAvailabilityList(oneToOneRequest);
        }
    };

    favoriteUserById = (id, type) => {
        this.setState({
            favUserId: id,
            sessionType: type,
        });
        getData(LOGIN).then((data) => {
            if (!isEmpty(data)) {
                this.props.favouriteUser(
                    data.token,
                    data.api_token,
                    id,
                    this.props.account_management &&
                    this.props.account_management.userDetails &&
                    this.props.account_management.userDetails.broadcaster.length > 0 &&
                    this.props.account_management.userDetails.broadcaster[0]
                        .availability[0].broadcast[0].id
                );
            }
        });
    };

    unFavoriteUserById = (id, type) => {
        this.setState({
            favUserId: id,
            sessionType: type,
        });
        getData(LOGIN).then((data) => {
            if (!isEmpty(data)) {
                this.props.unFavouriteUser(
                    data.token,
                    data.api_token,
                    id,
                    this.props.account_management &&
                    this.props.account_management.userDetails &&
                    this.props.account_management.userDetails.broadcaster.length > 0 &&
                    this.props.account_management.userDetails.broadcaster[0]
                        .availability[0].broadcast[0].id
                );
            }
        });
    };

    blockUserById = (id, type) => {
        this.setState({
            blockUserId: id,
            sessionType: type,
        });
        getData(LOGIN).then((data) => {
            if (!isEmpty(data)) {
                this.props.blockUser(data.token, data.api_token, id);
            }
        });
    };

    unBlockUserById = (id, type) => {
        this.setState({
            blockUserId: id,
            sessionType: type,
        });
        getData(LOGIN).then((data) => {
            if (!isEmpty(data)) {
                this.props.unBlockUser(data.token, data.api_token, id);
            }
        });
    };

    removeUserRequestByReqId = (req_id, type, user_id) => {
        this.setState({
            req_id: req_id,
            sessionType: type,
            favUserId: user_id
        });
        getData(LOGIN).then((data) => {
            if (!isEmpty(data)) {
                this.props.removeUserRequest(
                    data.token,
                    data.api_token,
                    req_id,
                    this.props.account_management &&
                    this.props.account_management.userDetails &&
                    this.props.account_management.userDetails.broadcaster[0]
                        .availability[0].broadcast[0].id
                );
            }
        });
    };

    selectAllToggle = () => {
        this.setState({
            selectAllCheckbox: !this.state.selectAllCheckbox,
            checkboxStore: []
        }, () => {
            if (this.state.selectAllCheckbox) {
                let requestIds = [];
                this.props.availability.groupAvailabilityList.map((request) => {
                    requestIds.push(request.id);
                });

                vuePayLog(screename,"selectAllToggle >> checkboxStore >> prev", this.state.checkboxStore)
                this.setState({
                    checkboxStore: requestIds
                }, () => {
                    vuePayLog(screename,"selectAllToggle >> checkboxStore >> new", this.state.checkboxStore)
                })
            }
        });
    };

    checkboxToggle = (event) => {
        const stringToIntValue = parseInt(event.target.value);

        let checkboxStore = this.state.checkboxStore;
        let present = checkboxStore.includes(stringToIntValue);
        if (present) {
            //remove and update the state
            checkboxStore = checkboxStore.filter((id) => {
                return id !== stringToIntValue
            });

            this.setState({
                selectAllCheckbox: !present && this.state.selectAllCheckbox
            });
        } else {
            //please add into the array
            checkboxStore.push(stringToIntValue)
        }

        vuePayLog(screename,"checkboxToggle >> stringToIntValue", stringToIntValue)
        vuePayLog(screename,"checkboxToggle >> checkboxStore >> prev", this.state.checkboxStore)
        this.setState({
            checkboxStore,
        }, () => {
            vuePayLog(screename,"checkboxToggle >> checkboxStore >> new", this.state.checkboxStore)
        });

    };

    componentDidMount() {
        this.props.showLeftBar(); //hide the leftbar
        window.scrollTo(0, 0);
        document.getElementsByClassName("modal-overlay")[0].style.display = "none";

        if(this.props.hasOwnProperty("location") && this.props.location.hasOwnProperty("state") && this.props.location.state && this.props.location.state.hasOwnProperty("activeTab")){
            this.setState({
                activeTab:this.props.location.state.activeTab
            })
        }
        //this.getRequestsData();
    }

    checkBroadcasterAvialability = () => {
        return (
            this.props.account_management.userDetails &&
            this.props.account_management.userDetails.broadcaster.length > 0 &&
            this.props.account_management.userDetails.broadcaster[0].availability
                .length > 0
        );
    };

    requestCloseAvailability = () => {
        const modal = document.getElementById("availability-close-confirmation");
        showModal(modal);
    };

    submitCloseAvailability = () => {
        const modal = document.getElementById("availability-close-confirmation");
        getData(LOGIN).then((data) => {
            if (!isEmpty(data)) {
                this.checkBroadcasterAvialability(
                    this.props.account_management.userDetails
                ) &&
                unsubscribeToFireStore(
                    this.props.account_management &&
                    this.props.account_management.userDetails.broadcaster[0].availability[0].broadcast[0].id.toString()
                );
                this.checkBroadcasterAvialability(
                    this.props.account_management.userDetails
                ) &&
                this.props.closeAvailability(
                    data.token,
                    data.api_token,
                    this.props.account_management.userDetails.broadcaster[0]
                        .availability[0].id
                );
                // this.props.history.push("/broadcaster/availability");
                this.props.resetAvailabilityList();
            }
        });
        hideModal(modal);
    };

    broadcasterAcceptRequestData = (id, type) => {
        let viewer = this.props.availability.oneToOneAvailabilityList.filter(
            (req) => req.id == id
        );
        this.setState({
            viewer: viewer[0],
            broadcasterRequestId: id,
            broadcasterRequestIds: [],
            broadcasterType: type,
        });
    };

    submitBroadcasterAcceptRequest = (actionType) => {
        this.setState({
            broadcasterType: actionType,
        });

        getData(LOGIN).then((data) => {
            if (!isEmpty(data)) {
                let acceptData;
                if (actionType === "onetoone") {
                    acceptData = {
                        request_id: this.state.broadcasterRequestId,
                        request_ids: this.state.broadcasterRequestIds,
                        request_type: this.state.broadcasterType,
                    };
                } else {
                    acceptData = {
                        request_id: null,
                        request_ids: this.state.checkboxStore,
                        request_type: actionType,
                    };
                }

                this.props.broadcasterAcceptRequest(
                    data.token,
                    data.api_token,
                    this.props.account_management.userDetails.broadcaster[0]
                        .availability[0].id,
                    acceptData
                );
            }
        });
    };

    // Handle Search data
    onSearchChange = (e, target, value, _list, _filteredlist, _found) => {

        const obj = {};
        let list, filteredlist, found;

        if (e) {
            target = e.target.name;
            value = e.target.value;
            list = e.target.getAttribute("data-list");
            filteredlist = e.target.getAttribute("data-filterlist");
            found = e.target.getAttribute("data-found");
        } else {
            list = _list;
            filteredlist = _filteredlist;
            found = _found;
        }
        obj[target] = value;

        this.setState(obj, () => {
            this.filterList(this.state[target], list, filteredlist, found)
        });
    };

    filterList = (value, list, filteredlist, found) => {
        const requestList = this.props.availability[list];
        const result = requestList.filter(request => request.username.toLowerCase().indexOf(value.toLowerCase().trim()) >= 0);

        const obj = {};
        obj[filteredlist] = result;
        obj[found] = result.length === 0;
        this.setState(obj)
    };

    // --/-- //
    showRequestTipDataListModal = () => {

        getData(LOGIN).then((data) => {
            if (!isEmpty(data)) {


                this.props.showTipListModal();
            } else {

                this.props.history.push({
                    pathname: "/login",
                    state: {basePath: this.props.history.location.pathname},
                });
            }
        });
    };

    // --/-- //

    render() {
        /**
         * TODO
         * update the Left bar to show broadcaster related menu
         */

        const onetooneRequestCount = getRequestCount(this.props.availability, "onetoone");
        const groupRequestCount = getRequestCount(this.props.availability, "group");
        return (
            <div>
                <main role="main" className="">
                    <div className="broadcast-container-parent row">
                        <div className="broadcast-container broadcast-type" style={{width: '100%'}}>
                            <Row className="mx-2 no-padding no-margin">
                                <Col md="6" className="text-left px-0">
                                    <span className="request-s-received">Request(s) Received</span>
                                </Col>
                                <Col md="6" className="text-right px-0">
                                    <ShareButtonComponent shareList={this.state.shareList} icon/>

                                    <ButtonIconWithTooltip
                                        id="help"
                                        icon={helpAvailability}
                                        tooltip={"Help!"}
                                        isOpen={this.state.helpTooltipOpen}
                                        toggle={() => {
                                            this.setState(prevState => ({
                                                helpTooltipOpen: !prevState.helpTooltipOpen
                                            }));
                                        }}
                                        onClick={() => console.log("Clicked on help")}/>


                                    <ButtonIconWithTooltip
                                        id="close-availability"
                                        icon={closeAvailability}
                                        tooltip={"Close Availability!"}
                                        isOpen={this.state.closeTooltipOpen}
                                        toggle={() => {
                                            this.setState(prevState => ({
                                                closeTooltipOpen: !prevState.closeTooltipOpen
                                            }));
                                        }}
                                        onClick={() => this.requestCloseAvailability()}/>

                                </Col>
                            </Row>
                            <div className="wrapper px-0">
                                <React.Fragment>
                                    <div className="bg-white">

                                        <RequestReceivedTabComponent
                                            activeTab={this.state.activeTab}
                                            oneToOneRequestCount={onetooneRequestCount}
                                            groupRequestCount={groupRequestCount}
                                            toggle={this.toggle} />

                                        <TabContent activeTab={this.state.activeTab}>
                                            <TabPane tabId="1">

                                                <RequestSearchComponent
                                                    name={"getOneToOneSearchValue"}
                                                    list={"oneToOneAvailabilityList"}
                                                    filterList={"searchedOneToOneData"}
                                                    found={"searchedOneToOneDataStatus"}
                                                    requestCount={onetooneRequestCount}
                                                    searchValue={this.state.getOneToOneSearchValue}
                                                    clearSearch={() => {
                                                        const list = "oneToOneAvailabilityList",
                                                            filteredlist = "searchedOneToOneData",
                                                            found = "searchedOneToOneDataStatus";
                                                        this.onSearchChange(null, "getOneToOneSearchValue", "", list, filteredlist, found)
                                                    }}
                                                    updateSearchValue={this.onSearchChange}
                                                    searchRequest={() => {
                                                        const list = "oneToOneAvailabilityList",
                                                            filteredlist = "searchedOneToOneData",
                                                            found = "searchedOneToOneDataStatus";
                                                        this.filterList(this.state.getOneToOneSearchValue, list, filteredlist, found)
                                                    }}/>

                                                <Row className="mx-0">
                                                    <Col sm="12" className="px-0">
                                                        <Row className="mx-0">
                                                            <OneonOneRequests
                                                                availability={this.props.availability}
                                                                submitBroadcasterAcceptRequest={this.submitBroadcasterAcceptRequest}
                                                                searchStatus={this.state.searchedOneToOneDataStatus}
                                                                searchData={this.state.searchedOneToOneData}
                                                                requestCount={onetooneRequestCount}
                                                                requests={this.props.availability.oneToOneAvailabilityList}
                                                                requestMessage={"has requested a 1-on-1 session"}
                                                                shareList={this.state.shareList}
                                                                isChecked={this.state.isChecked}
                                                                radioToggle={this.radioToggle}
                                                                favoriteUserById={this.favoriteUserById}
                                                                unFavoriteUserById={this.unFavoriteUserById}
                                                                blockUserById={this.blockUserById}
                                                                removeUserRequestByReqId={this.removeUserRequestByReqId}
                                                                broadcasterAcceptRequestData={this.broadcasterAcceptRequestData}/>
                                                        </Row>
                                                    </Col>
                                                </Row>


                                            </TabPane>
                                            <TabPane tabId="2">


                                                <RequestSearchComponent
                                                    name={"getGroupSearchValue"}
                                                    list={"groupAvailabilityList"}
                                                    filterList={"searchedGroupData"}
                                                    found={"searchedGroupDataStatus"}
                                                    requestCount={groupRequestCount}
                                                    searchValue={this.state.getGroupSearchValue}
                                                    clearSearch={() => {
                                                        const list = "groupAvailabilityList",
                                                            filteredlist = "searchedGroupData",
                                                            found = "searchedGroupDataStatus";
                                                        this.onSearchChange(null, "getGroupSearchValue", "", list, filteredlist, found)
                                                    }}
                                                    updateSearchValue={this.onSearchChange}
                                                    searchRequest={() => {
                                                        const list = "groupAvailabilityList",
                                                            filteredlist = "searchedGroupData",
                                                            found = "searchedGroupDataStatus";
                                                        this.filterList(this.state.getGroupSearchValue, list, filteredlist, found)
                                                    }}/>


                                                <Row className="mx-0">
                                                    <Col sm="12" className="px-0 full-width">
                                                        <Row className="mx-0">
                                                            <GroupRequests
                                                                selectAllCheckbox={this.state.selectAllCheckbox}
                                                                selectAllToggle={this.selectAllToggle}
                                                                checkboxStore={this.state.checkboxStore}
                                                                availability={this.props.availability}
                                                                submitBroadcasterAcceptRequest={this.submitBroadcasterAcceptRequest}
                                                                searchStatus={this.state.searchedGroupDataStatus}
                                                                searchData={this.state.searchedGroupData}
                                                                requestCount={groupRequestCount}
                                                                requests={this.props.availability.groupAvailabilityList}
                                                                requestMessage={"has requested a group session"}
                                                                shareList={this.state.shareList}
                                                                isChecked={this.state.isChecked}
                                                                checkboxToggle={this.checkboxToggle}
                                                                favoriteUserById={this.favoriteUserById}
                                                                unFavoriteUserById={this.unFavoriteUserById}
                                                                blockUserById={this.blockUserById}
                                                                removeUserRequestByReqId={this.removeUserRequestByReqId}
                                                                broadcasterAcceptRequestData={this.broadcasterAcceptRequestData}/>
                                                        </Row>
                                                    </Col>
                                                </Row>

                                            </TabPane>
                                        </TabContent>
                                    </div>
                                </React.Fragment>
                            </div>
                        </div>
                        <ConfirmationModal
                            submitCloseAvailability={this.submitCloseAvailability}
                        />
                    </div>
                </main>
            </div>
        );
    }
}

function mapStateToProps(state) {
    return {
        account_management: state.account_management,
        availability: state.availability,
        broadcast: state.broadcast,
        get_broadcast_earnings: state.get_broadcast_earnings,
        broadcaster_detail_management: state.broadcaster_detail_management,
        broadcaster_favourites: state.broadcaster_favourites,
        broadcaster_block_unblock_viewer: state.broadcaster_block_unblock_viewer,
        device: state.device.payload,
        // tip
        tip: state.tip,
        showTipListModalFlag: state.flag.showTipListModalFlag,
    };
}

export default connect(mapStateToProps, actions)(BroadcastAvailabilityRequests);
